<template>
  <div class="card">
    <div class="card-header">
      <strong>References</strong>
    </div>
    <div class="card-body form-horizontal">
      <div class="card-block">
        <div class="form-group row">
          <label class="col-md-2">Choosen references</label>
          <div class="col-md-10">
            <table class="references-table table table-bordered table-striped table-sm">
              <thead>
                <tr>
                  <td>ID</td>
                  <td>Title</td>
                  <td>Type</td>
                  <td>Actions</td>
                </tr>
              </thead>
              <tbody v-if="choosenRefs.length">
                <tr
                  v-for="item in choosenRefs"
                  :key="item.type + item.id"
                  :data-id="item.type + item.id"
                >
                  <td>{{ item.id }}</td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.type }}</td>
                  <td class="table-list__cell--narrow">
                    <button class="btn btn-danger" @click="deleteRef(item)">Delete</button>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4">There are no content</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2">Reference type</label>
          <div class="col-md-10">
            <vue-select
              v-model="refType"
              :options="refTypeOptions"
            />
          </div>
        </div>

        <div v-if="refType" class="form-group row">
          <label class="col-md-2">Reference entity</label>
          <div class="col-md-10">
            <vue-select
              ref="refEntityModel"
              v-model="refEntity"
              multiple
              :filterable="false"
              :options="refEntityOptions"
              label="id"
              @search="onEntitySearch"
            >
              <template slot="no-options">
                type to search...
              </template>
              <template slot="option" slot-scope="option">
                {{ option.title }}
              </template>
              <template slot="selected-option" slot-scope="option">
                {{ option.title }}
              </template>
            </vue-select>
          </div>
        </div>

        <div v-if="refType && refEntity && refEntity.length" class="form-group row">
          <div class="col-md-12">
            <button class="btn btn-success" @click="addRef">Add</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import VueSelect from 'vue-select';

export default {
  name: 'Referencer',

  components: {
    'vue-select': VueSelect,
  },

  props: {
    alreadyChoosenRefs: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      refType: null,
      refEntityOptions: [],
      refEntity: null,
      choosenRefs: [],
    };
  },

  computed: {
    refTypeOptions() {
      const array = [];
      _.forEach(this.$store.state.contentTypes.list, (item, key) => {
        array.push({
          label: this.snakeToTitle(key),
          key,
        });
      });
      return array;
    },
  },

  watch: {
    refType() {
      this.refEntityOptions = [];
      this.refEntity = null;
      if (this.$refs.refEntityModel) {
        this.$refs.refEntityModel.onEscape();
      }
    },
  },

  mounted() {
    this.choosenRefs = _.cloneDeep(this.alreadyChoosenRefs);
  },

  methods: {
    snakeToTitle(str) {
      return str.split('_').map(item => item.charAt(0).toUpperCase() + item.substring(1)).join(' ');
    },
    onEntitySearch(search, loading) {
      loading(true);
      this.entitySearch(loading, search, this, this.refType.key);
    },
    entitySearch: _.debounce((loading, search, vm, contentType) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.host + vm.$config.app_api.prefix}content-types/${contentType}`, {
        params: {
          search_string: escape(search),
        },
      }).then((response) => {
        const newDataArr = [];
        _.forIn(response.data, (value, key) => {
          if (key !== 'meta') {
            newDataArr.push(value);
          }
        });
        context.refEntityOptions = newDataArr;
        loading(false);
      }).catch((reject) => {
        console.error(reject);
      });
    }, 350),
    addRef() {
      for (let i = 0; i < this.refEntity.length; i += 1) {
        this.refEntity[i].type = this.refType.key;
        this.choosenRefs.push(this.refEntity[i]);
      }
      this.refEntity = null;
      this.refEntityOptions = [];
      this.refType = null;
      this.$emit('changeRefs', this.choosenRefs);
    },
    deleteRef(el) {
      _.remove(this.choosenRefs, item => item.id === el.id && el.type === item.type);
      this.$forceUpdate();
      this.$emit('changeRefs', this.choosenRefs);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Referencer.vue?cd1c9c9e